import {action, computed, observable} from 'mobx';

export interface INotificationController {
    show(): void;
    hide(): void;
    updateContent(content: string, isError?: boolean): void;
    readonly isVisible: boolean;
    readonly content: string;
    readonly isError: boolean;
}

export class NotificationController implements INotificationController {
    @observable private _isVisible: boolean = false;
    @observable private _content: string = '';
    @observable private _isError: boolean = false;

    @computed
    get isVisible(): boolean {
        return this._isVisible;
    }

    @computed
    get content(): string {
        return this._content;
    }

    @computed
    get isError(): boolean {
        return this._isError;
    }

    @action
    show(): void {
        this._isVisible = true;
    }

    @action
    hide(): void {
        this._isVisible = false;
    }

    @action
    updateContent(content: string, isError: boolean = false): void {
        this._content = content;
        this._isError = isError;
    }
}
